import useToastMessage from './use-toast-message'

// interface Options {
//   flash?: {
//     group?: string
//   }
// }

// const defaultOptions: Options = { flash: {} }

const useFeedbackMessage = () => {
  const toast = useToastMessage()

  return { toast }
}

export default useFeedbackMessage
